<template>
  <section
    id="education"
    class="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
  >
    <div class="flex items-end justify-between">
      <h2
        class="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900"
      >
        EDUCATION
      </h2>
      <span class="text-sm text-neutral-500">Snapshots</span>
    </div>
    <div class="mt-10 grid gap-6 md:grid-cols-3">
      <div
        v-for="(edu, index) in education"
        :key="index"
        class="rounded-2xl bg-white ring-1 ring-neutral-200 p-6 hover:shadow-sm transition"
      >
        <div class="flex items-center gap-3">
          <span
            :class="[
              'h-10 w-10 rounded-lg flex items-center justify-center',
              edu.bgColor
            ]"
          >
            <component :is="getIconComponent(edu.icon)" :size="20" :class="edu.iconColor" />
          </span>
          <div>
            <p class="text-neutral-900 font-medium">
              {{ edu.title }}
            </p>
            <p class="text-sm text-neutral-600">{{ edu.institution }}</p>
          </div>
        </div>
        <p class="mt-4 text-neutral-700 text-[15px] leading-relaxed">
          {{ edu.description }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { GraduationCap, BadgeCheck, Palette, Megaphone } from 'lucide-vue-next'

export default {
  name: 'UIUXEducation',
  components: {
    GraduationCap,
    BadgeCheck,
    Palette,
    Megaphone
  },
  props: {
    education: {
      type: Array,
      default: () => [
        {
          title: 'BS Software Engineering',
          institution: 'FAST Islamabad • Ongoing',
          description: 'Foundations in algorithms, systems, and product-minded engineering.',
          icon: 'GraduationCap',
          iconColor: 'text-emerald-600',
          bgColor: 'bg-emerald-100'
        },
        {
          title: 'UI/UX Professional Certificate',
          institution: 'Issued by Meta',
          description: 'End‑to‑end UX process: research, flows, wireframes, prototyping, and testing.',
          icon: 'BadgeCheck',
          iconColor: 'text-sky-600',
          bgColor: 'bg-sky-100'
        },
        {
          title: 'Graphic Design 101',
          institution: 'Certification — Canva',
          description: 'Visual hierarchy, color theory, typography, and layout essentials.',
          icon: 'Palette',
          iconColor: 'text-pink-600',
          bgColor: 'bg-pink-100'
        },
        {
          title: 'Marketing with Canva',
          institution: 'Certification — Canva',
          description: 'Content strategy, brand assets, and multi‑channel creative production.',
          icon: 'Megaphone',
          iconColor: 'text-amber-600',
          bgColor: 'bg-amber-100'
        }
      ]
    }
  },
  methods: {
    getIconComponent(iconName) {
      const iconMap = {
        GraduationCap,
        BadgeCheck,
        Palette,
        Megaphone
      }
      return iconMap[iconName] || GraduationCap
    }
  }
}
</script>

